import Button from '2-core-elements/Buttons/Button';
import Icon, { type IconString } from '2-core-elements/Icon/Icon';
import InlineMessage from '3-components/InlineMessage/InlineMessage';
import LoadingIndicator from '3-components/LoadingIndicator/LoadingIndicator';
import { type FC } from 'react';
import { type ListingLinkProps } from '../ListingContent/ListingContent';

export interface ListingUILabel {
    errorMessage: string;
    loadingMessage?: string;
    noItemLabel: string;
    noItemMessage?: string;
    noItemPrimaryAction?: ListingLinkProps;
    noItemSecondaryAction?: ListingLinkProps;
}

type ListingLoaderProps = Pick<ListingUILabel, 'loadingMessage'>;

export const ListingLoader: FC<ListingLoaderProps> = ({ loadingMessage }) => {
    return (
        <div className="listing-loader">
            <LoadingIndicator loadingText={loadingMessage} className="sg-eg-loader" />
        </div>
    );
};

type ListingErrorProps = Pick<ListingUILabel, 'errorMessage'>;

export const ListingError: FC<ListingErrorProps> = ({ errorMessage }) => {
    return (
        <div className="listing-app">
            <div className="container">
                <InlineMessage status="error">
                    <p>{errorMessage}</p>
                </InlineMessage>
            </div>
        </div>
    );
};

type ListingNoItemProps = Pick<ListingUILabel, 'noItemMessage' | 'noItemLabel' | 'noItemPrimaryAction' | 'noItemSecondaryAction'>;

export const ListingNoItem: FC<ListingNoItemProps> = ({ noItemLabel, noItemMessage, noItemPrimaryAction, noItemSecondaryAction }) => {
    return (
        <div className="listing-no-item">
            <div className="listing-no-item-container">
                <div className="listing-no-item-icon-box">
                    <Icon className="listing-no-item-icon" icon="search" />
                </div>
                <div className="listing-no-item-description">
                    <h3>{noItemLabel}</h3>
                    { noItemMessage && <p>{noItemMessage}</p> }
                </div>
                {(noItemPrimaryAction || noItemSecondaryAction) && (
                    <div className="listing-no-item-actions">
                        {noItemPrimaryAction && (
                            <Button
                                href={noItemPrimaryAction.link}
                                className="no-item-action"
                                suffixIcon={noItemPrimaryAction.icon ? noItemPrimaryAction.icon as IconString : undefined }
                            >
                                {noItemPrimaryAction.label}
                            </Button>
                        )}
                        {noItemSecondaryAction && (
                            <Button
                                skin={'2'}
                                href={noItemSecondaryAction.link}
                                className="no-item-action"
                                suffixIcon={noItemSecondaryAction.icon ? noItemSecondaryAction.icon as IconString : undefined }
                            >
                                {noItemSecondaryAction.label}
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
